import SideBanner from "components/Banner/SideBanner";

import background01 from "../../assets/images/svg/loginImages/background01.svg";
import background02 from "../../assets/images/svg/loginImages/background02.svg";
import background03 from "../../assets/images/svg/loginImages/background03.svg";
import background04 from "../../assets/images/svg/loginImages/background04.svg";

const shuffle = (array: any[]) => {
  let currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
};

const imagesOnDirectory = shuffle([
  { img: background01 },
  { img: background02 },
  { img: background03 },
  { img: background04 },
]);

function BackgroundSlider() {
  return (
    <SideBanner overflow={"hidden"}>
      {imagesOnDirectory.map((image, index) => (
        <img
          key={index}
          src={image.img}
          width={"100%"}
          height={"100%"}
          style={{
            scale: "2",
            transform: "translateX(-20%)",
          }}
        />
      ))}
    </SideBanner>
  );
}
BackgroundSlider.defaultProps = {
  duration: 10,
};
export default BackgroundSlider;
